import PropTypes from 'prop-types'
import { Power as PowerOnIcon } from '@mui/icons-material'
import PowerOffIcon from '@mui/icons-material/PowerOff'
import styled, { css } from 'styled-components'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

import { color } from 'styles/colors'

const propTypes = {
  isConnected: PropTypes.bool,
  className: PropTypes.string,
  showToolTip: PropTypes.bool,
  size: PropTypes.string
}

const defaultProps = {
  isConnected: false,
  className: null,
  showToolTip: true,
  size: '18px'
}

const ConnectedStatusIcon = ({ isConnected, size = '18px', className, showToolTip = true }) => {
  const iconTooltip = `This thermostat is ${isConnected ? 'connected' : 'disconnected'}`

  const StatusIcon = () => {
    return isConnected
      ? <S.PowerOnIcon aria-label="connected" size={size} {...{ className }} />
      : <S.PowerOffIcon aria-label="disconnected" size={size} {...{ className }} />
  }

  if (showToolTip) {
    return (
      <Tooltip title={iconTooltip} placement="top" >
        <S.Container readOnly>
          <StatusIcon />
        </S.Container>
      </Tooltip>
    )
  } else {
    return (
      <StatusIcon />
    )
  }
}

ConnectedStatusIcon.propTypes = propTypes
ConnectedStatusIcon.defaultProps = defaultProps

export default ConnectedStatusIcon

const iconStyle = (size, iconType) => {
  return css`
    font-size: ${size};
    color: ${color(iconType)};
    border: 1px solid ${color(iconType)};
    border-radius: 50%;
  `
}

const S = {
  Container: styled(KeyboardAccessible)`
    margin-left: 5px;
    padding: 2px 3px 0;
    height: 24px;

    svg {
      position: unset;
      margin-left: 0;
    }
  `,
  PowerOnIcon: styled(PowerOnIcon)`
  ${({ size }) => {
    return iconStyle(size, 'connected')
  }}
  `,
  PowerOffIcon: styled(PowerOffIcon)`
    ${({ size }) => {
    return iconStyle(size, 'disconnected')
  }}
  `
}
